import type { User, Tenant, Language, Theme } from '@/types'

export interface ModuleSettings {
  commercial: boolean
  agent: boolean
  voiceNotes: boolean
  devCenter: boolean
}

export const DEFAULT_MODULE_SETTINGS: ModuleSettings = {
  commercial: false,
  agent: false,
  voiceNotes: false,
  // Dev Center es una herramienta interna de admin → disponible por defecto
  // (el super admin puede desactivarla por tenant). Los demás son módulos opt-in.
  devCenter: true,
}

export interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  initialized: boolean
  currentTenant: Tenant | null
  impersonatingTenantId: string | null
  moduleSettings: ModuleSettings
}

export const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
  initialized: false,
  currentTenant: null,
  impersonatingTenantId: null,
  moduleSettings: { ...DEFAULT_MODULE_SETTINGS },
}

export interface UserPreferences {
  language: Language
  theme: Theme
}
